import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_mynq63kmmf: FaireBrandEntity = {
  token: "b_mynq63kmmf",
  type: "brand",
  name: "Relax Away Essentials",
  avatarUrl:
    "https://cdn.faire.com/fastly/f70ad36f43f1d15e960cbacab7869dab24a52edaa260f2b60b797599df504f6e.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/fef1333c050fe301f7b938bec4e6d241b3ed325530f54d13ea80965fbf7031de.png",
  logoUrl:
    "https://cdn.faire.com/fastly/f70ad36f43f1d15e960cbacab7869dab24a52edaa260f2b60b797599df504f6e.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/fef1333c050fe301f7b938bec4e6d241b3ed325530f54d13ea80965fbf7031de.png",
  location: "Hillsboro, MO, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 189,
  isTopShop: true,
  isInsider: true,
  description:
    "We are a small family owned business in Missouri dedicated to providing high quality products for everyone to enjoy! We started our business in 2018 after a few tragic life events as a way to distract ourselves and fell in love with being entrepreneurs and even more in love with providing wellness products to our amazing customers! Our best selling shower steamers are some of our favorite products and we think they are perfect for the Faire platform! Hopefully your customers love them just as much as we do and the thousands of happy customers we have reached so far! ",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:45.587Z",
    importedBy: "entity-db-cli",
  },
};
